export type RichTextBlockFormat = 'blockquote' | 'h1' | 'h2' | 'h3' | 'p';

export const HEADING_ELEMENTS = new Set(['h1', 'h2', 'h3']);

export function restoreSelection(range: Range | null) {
  if (!range) {
    return;
  }

  const selection = window.getSelection();

  if (!selection) {
    return;
  }

  selection.removeAllRanges();
  selection.addRange(range);
}

export function getCurrentSelectionRange(node: HTMLDivElement | null) {
  if (!node) {
    return null;
  }

  const selection = window.getSelection();

  if (!selection || selection.rangeCount < 1) {
    return null;
  }

  const range = selection.getRangeAt(0);
  const commonAncestor = range.commonAncestorContainer;

  if (!node.contains(commonAncestor)) {
    return null;
  }

  return range.cloneRange();
}

export function getSelectionPath(node: HTMLDivElement) {
  const selection = window.getSelection();

  if (!selection || selection.rangeCount < 1) {
    return 'p';
  }

  const anchorNode = selection.anchorNode;

  if (!anchorNode || !node.contains(anchorNode)) {
    return 'p';
  }

  const path: Array<string> = [];
  let currentNode: Node | null =
    anchorNode.nodeType === Node.TEXT_NODE ? anchorNode.parentNode : anchorNode;

  while (currentNode && currentNode !== node) {
    if (currentNode instanceof HTMLElement) {
      path.unshift(currentNode.tagName.toLowerCase());
    }

    currentNode = currentNode.parentNode;
  }

  return path.join(' > ') || 'p';
}

export function getSelectedFormat(node: HTMLDivElement): RichTextBlockFormat {
  const selection = window.getSelection();

  if (!selection || selection.rangeCount < 1) {
    return 'p';
  }

  const anchorNode = selection.anchorNode;

  if (!anchorNode || !node.contains(anchorNode)) {
    return 'p';
  }

  let currentNode: Node | null =
    anchorNode.nodeType === Node.TEXT_NODE ? anchorNode.parentNode : anchorNode;

  while (currentNode && currentNode !== node) {
    if (currentNode instanceof HTMLElement) {
      const tagName = currentNode.tagName.toLowerCase();

      if (
        'blockquote' === tagName ||
        'h1' === tagName ||
        'h2' === tagName ||
        'h3' === tagName ||
        'p' === tagName
      ) {
        return tagName;
      }
    }

    currentNode = currentNode.parentNode;
  }

  return 'p';
}

export function moveCaretToEnd(node: HTMLDivElement) {
  const selection = window.getSelection();

  if (!selection) {
    return;
  }

  const range = document.createRange();
  range.selectNodeContents(node);
  range.collapse(false);
  selection.removeAllRanges();
  selection.addRange(range);
}

export function replaceEditorHTML(node: HTMLDivElement, html: string) {
  const fragment = createSafeFragment(html);
  node.replaceChildren(fragment);
}

export function createSafeFragment(html: string) {
  const parser = new DOMParser();
  const documentNode = parser.parseFromString(html, 'text/html');
  const fragment = document.createDocumentFragment();

  Array.from(documentNode.body.childNodes).forEach((childNode) => {
    fragment.appendChild(childNode.cloneNode(true));
  });

  return fragment;
}

export function getSelectedText() {
  return window.getSelection()?.toString() ?? '';
}
